<template>
  <div class="w5">
    <el-tabs v-model="tabsIndex3" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in creditrOrdertype" :label="item.name" :key="index">
        <ul class="ul2">
          <li v-for="(items, child) in creditrOrderdataList" :key="child">
            <div class="txtbox">
              <h2 class="textover">{{ items.commodityName }}</h2>
              <div class="">
                <p class="textover color888"><span>收件人</span>{{ items.userName }}</p>
                <p class="textover color888"><span>联系方式</span>{{ items.contact }}</p>
              </div>
              <p class="textover color888"><span>收件地址</span>{{ items.address }}</p>
              <p class="textover color888"><span>备注</span>{{ items.remark }}</p>
            </div>
          </li>
        </ul>
        <nodata v-if="creditrOrderdataList && creditrOrderdataList.length === 0" nodataflag="true"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getuserpointorderList } from '@/api/user/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'usercreditorder',
  components: {
    nodata
  },
  data () {
    return {
      tabsIndex3: 0,
      creditrOrderdataList: [],
      creditrOrdertype: [
        {
          id: 1,
          name: '全部',
          state: ''
        }, {
          id: 2,
          name: '未处理',
          state: 1
        }, {
          id: 3,
          name: '已处理',
          state: 2
        }, {
          id: 4,
          name: '已撤销',
          state: 3
        }
      ],
      creditorder: {
        pageNum: 1,
        limit: 12,
        state: ''
      }
    }
  },
  mounted () {
    this.userpointorder()
  },
  methods: {
    handleClick (tab, event) {
      let currentId = event.target.id.split('-')[1]
      if (parseInt(currentId) === 0) {
        this.creditorder.state = ''
      } else {
        this.creditorder.state = parseInt(currentId)
      }
      this.userpointorder()
    },
    /* 积分订单 */
    userpointorder () {
      getuserpointorderList(this.$cookie.get('culturalCloud_fid'), this.creditorder).then(res => {
        if (res.data.status === 0) {
          this.creditrOrderdataList = res.data.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/user.scss";
.ul2{
  li{
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/usercreditorder.vue